import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\">\n<circle cx=\"16\" cy=\"16\" r=\"15.25\" stroke=\"#EFEFEF\" stroke-width=\"1.5\" />\n<path d=\"M12.4473 16.0003V12.1999C12.4473 10.6025 14.2276 9.64975 15.5567 10.5358L18.1003 12.2316L21.2573 14.3362C22.4447 15.1279 22.4447 16.8728 21.2573 17.6644L18.1003 19.769L15.5567 21.4648C14.2276 22.3509 12.4473 21.3981 12.4473 19.8007V16.0003Z\" fill=\"#4D4D4D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol